import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { fetchP24TransactionRefundsDataByP24 } from "../../actions/p24TransactionActions";

class P24TransactionRefundsDataByP24 extends React.Component {

    componentDidMount() {

        this.props.fetchP24TransactionRefundsDataByP24(this.props.transaction.id);
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit();
    };


    render() {

        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">Dane transakcji w systemie P24</h2>
                </div>

                <div className="w3-container w3-theme-l3">
                    <h5 className="w3-center">Dane transakcyjne</h5>
                </div>

                <div className="w3-row-padding">


                </div>

                <div className="w3-container w3-theme-l3">
                    <h5 className="w3-center">Dane klienta</h5>
                </div>


                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            Zamknij
                        </button>
                    </div>
                </form>
            </div >
        )
    }

}

P24TransactionRefundsDataByP24.propTypes = {
    //dane wejsciowe obiektu do wypelnienia
    transaction: PropTypes.object.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    p24TransactionRefundsDataByP24: state.p24TransactionReducer.p24TransactionRefundsDataByP24
});

const mapDispatchToProps = ({
    fetchP24TransactionRefundsDataByP24: fetchP24TransactionRefundsDataByP24
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24TransactionRefundsDataByP24);